
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoindorecab() {



    const cardData =
    {
        keyword: 'Pune to Indore Cab ',
        heading: 'Platinum24 Cabs: Pune to Indore Cab',
        headingDescription: ' Platinum24 Cabs provides reliable Pune to Indore cab services, perfect for business travelers, family visits, and tourists. Whether you’re heading to Indore for corporate work, exploring Rajwada Palace and Lal Bagh, or visiting family, our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a safe and comfortable ride. With professional chauffeurs, punctual pickups, and fully transparent pricing, we make your long-distance travel hassle-free. From one-way trips to round journeys, Platinum24 Cabs guarantees dependable service and a pleasant Pune to Indore travel experience.',

        top: 'Top Places to Visit in Indore with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Rajwada Palace",
    "description": "Rajwada Palace, built by the Holkars over 200 years ago, is Indore’s most iconic landmark. This seven-story structure blends Maratha, Mughal, and French architectural styles. The grand wooden entrance and intricate balconies reflect royal elegance. Light-and-sound shows narrate Holkar history. Surrounded by buzzing markets, it is a favorite tourist spot. Rajwada is Indore’s living royal heritage."
  },
  {
    "title": "Lal Bagh Palace",
    "description": "Lal Bagh Palace, constructed between 1886 and 1921, showcases the grandeur of the Holkar dynasty. Its interiors boast Italian marble, Persian carpets, and Belgian stained glass. The sprawling gardens add to its charm. The palace museum displays royal artifacts, paintings, and furniture. It reflects European-style architecture. Lal Bagh is Indore’s regal palace of luxury."
  },
  {
    "title": "Kanch Mandir",
    "description": "Kanch Mandir, also known as the Glass Temple, is a stunning Jain shrine in Indore. Built by Sir Seth Hukumchand in the early 20th century, it is adorned with Belgian glass and mirrors. The temple’s interiors shine with reflections, creating a mesmerizing effect. Jain scriptures and art are depicted on glass panels. It is both spiritual and artistic. Kanch Mandir is Indore’s dazzling devotional gem."
  },
  {
    "title": "Sarafa Bazaar",
    "description": "Sarafa Bazaar transforms into a vibrant street food paradise at night. Food lovers savor Indore’s iconic snacks like poha-jalebi, bhutte ki kees, sabudana khichdi, and malpua. The bustling lanes are filled with aromas, colors, and energy. It is open till late night, making it a unique food hub. Shoppers also enjoy jewelry stores in the daytime. Sarafa is Indore’s ultimate foodie hotspot."
  },
  {
    "title": "Chappan Dukan",
    "description": "Chappan Dukan, literally meaning ‘56 Shops,’ is Indore’s modern food street. It offers a variety of snacks, sweets, and global cuisines. From Indori poha to Chinese, visitors find endless choices. The area is clean, organized, and family-friendly. Street performances and festive lights add vibrancy. Chappan Dukan is Indore’s buzzing culinary destination."
  },
  {
    "title": "Central Museum (Indore Museum)",
    "description": "The Central Museum, also called Indore Museum, houses rare artifacts from the prehistoric to medieval era. Its collection includes sculptures from the Parmar dynasty, coins, and ancient tools. The Ganesh and Shiva statues are major highlights. History enthusiasts find it deeply enriching. The museum preserves Malwa’s heritage and culture. It is Indore’s knowledge hub of history."
  },
  {
    "title": "Annapurna Temple",
    "description": "Annapurna Temple is one of Indore’s most popular temples, dedicated to Goddess Annapurna, the goddess of food. Its grand entrance is adorned with elephants and sculpted figures. The temple’s architecture resembles South Indian gopurams. Devotees believe blessings here bring prosperity and nourishment. It is a spiritual retreat amidst the city’s bustle. Annapurna Temple is Indore’s sacred devotional site."
  },
  {
    "title": "Patalpani Waterfall",
    "description": "Patalpani Waterfall, about 35 km from Indore, is a scenic monsoon attraction. The falls plunge nearly 300 feet into a deep gorge. Surrounded by hills and greenery, it is a favorite picnic and trekking spot. Legends say the waters reach ‘patal’ (underworld). Visitors love its natural beauty, especially after rains. Patalpani is Indore’s refreshing nature escape."
  },
  {
    "title": "Ralamandal Wildlife Sanctuary",
    "description": "Ralamandal Wildlife Sanctuary, established in 1989, is Indore’s green getaway. It shelters deer, leopards, wild boar, and exotic birds. Trekking trails and jeep safaris attract adventure seekers. A hunting lodge built by Holkars still stands inside. The sanctuary is lush during monsoon and winter. Ralamandal is Indore’s eco-tourism hub."
  },
  {
    "title": "Janapav Hill",
    "description": "Janapav Hill, about 45 km from Indore, is the highest peak in Malwa region. It is believed to be the birthplace of Parashurama, the sixth avatar of Lord Vishnu. Surrounded by forests, the hill is popular for trekking. Monsoon brings waterfalls and mist, adding charm. Annual fairs attract pilgrims and tourists alike. Janapav is Indore’s sacred and scenic hill retreat."
  }
],


          "services": [
    {
      "name": "Pune to Indore Cab",
      "description": "Experience reliable and comfortable long-distance travel with our Pune to Indore Cab service. Whether you're traveling for business, family, or leisure, we offer clean vehicles, punctual pickups, and professional drivers to ensure a smooth interstate journey."
    },
    {
      "name": "Pune to Indore Taxi",
      "description": "Choose our Pune to Indore Taxi service for safe, timely, and convenient intercity transportation. With multiple vehicle options and trained drivers, we make your travel from Pune to Indore enjoyable and stress-free."
    },
    {
      "name": "Book Pune to Indore Cab",
      "description": "Book Pune to Indore Cab effortlessly through our online platform. Get instant confirmations, select your preferred car, and enjoy transparent pricing. Whether it's a solo trip or family outing, booking has never been easier."
    },
    {
      "name": "Pune to Indore Cab Service",
      "description": "Our Pune to Indore Cab Service provides dependable travel options across states. Enjoy sanitized vehicles, experienced drivers, and flexible pickup times, ensuring your journey is safe and comfortable throughout."
    },
    {
      "name": "Pune to Indore Cab Fare",
      "description": "Know your Pune to Indore Cab Fare in advance with our transparent pricing policy. We offer fixed and competitive rates with no hidden charges, helping you plan your travel budget effectively."
    },
    {
      "name": "Pune to Indore One Way Taxi",
      "description": "Travel one-way without paying extra with our Pune to Indore One Way Taxi service. Ideal for business travelers, students, or relocations, this service provides affordability without compromising on quality."
    },
    {
      "name": "Cab from Pune to Indore",
      "description": "Looking for a Cab from Pune to Indore? Our intercity taxi service ensures a smooth ride with a wide range of vehicle choices, including sedans, SUVs, and luxury cars, all driven by professional chauffeurs."
    },
    {
      "name": "Indore to Pune Cab Booking",
      "description": "Need a return ride? Our Indore to Pune Cab Booking service offers easy scheduling, competitive fares, and the same high-quality travel experience to get you back home comfortably and safely."
    },
    {
      "name": "Pune to Indore Car Rental",
      "description": "Explore flexible travel with our Pune to Indore Car Rental options. Choose between self-drive and chauffeur-driven rentals from a wide range of cars, perfect for personal or business trips."
    },
    {
      "name": "Affordable Cabs Pune to Indore",
      "description": "Looking for budget-friendly travel? Our Affordable Cabs from Pune to Indore offer excellent value with clean vehicles, courteous drivers, and cost-effective fares suitable for frequent and long-distance travelers."
    },
    {
      "name": "Pune to Indore Outstation Cab",
      "description": "Opt for our Pune to Indore Outstation Cab service for safe and efficient intercity travel. Designed for longer routes, our outstation cabs are equipped with comfortable seating, luggage space, and skilled drivers."
    },
    {
      "name": "Pune to Indore Sedan and SUV",
      "description": "Select your ideal vehicle with our Pune to Indore Sedan and SUV options. Whether you prefer the fuel efficiency of a sedan or the spacious comfort of an SUV, we have the right ride for your travel needs."
    },
    {
      "name": "Pune to Indore Cab Charges",
      "description": "Check Pune to Indore Cab Charges before booking with our clear and upfront pricing. We provide detailed fare breakdowns and assure no hidden fees, giving you complete control over your travel expenses."
    }
  ],
  "tableData": [
    ["Pune to Indore Cab", "Pune to Indore Taxi"],
    ["Book Pune to Indore Cab", "Pune to Indore Cab Service"],
    ["Pune to Indore Cab Fare", "Pune to Indore One Way Taxi"],
    ["Cab from Pune to Indore", "Indore to Pune Cab Booking"],
    ["Pune to Indore Car Rental", "Affordable Cabs Pune to Indore"],
    ["Pune to Indore Outstation Cab", "Pune to Indore Sedan and SUV"],
    ["Pune to Indore Cab Charges", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Dependable Pune to Indore Cab Service",
    "WhyChoosedescription": "Platinum24 Cabs offers reliable and comfortable cab services for your journey from Pune to Indore, ensuring a smooth and enjoyable ride."
  },
  {
    "WhyChooseheading": "Wide Selection of Vehicles for All Group Sizes",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and tempo travellers based on your travel needs for the Pune to Indore route."
  },
  {
    "WhyChooseheading": "Clean and Sanitized Cabs for Safe Travel",
    "WhyChoosedescription": "Every vehicle is thoroughly cleaned and sanitized before each trip to provide a safe and hygienic experience."
  },
  {
    "WhyChooseheading": "Skilled Drivers with Route Knowledge",
    "WhyChoosedescription": "Our professional drivers are well-acquainted with the Pune to Indore route, ensuring timely and efficient travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing Without Hidden Charges",
    "WhyChoosedescription": "Enjoy fair and clear pricing with no surprise costs—fuel, tolls, and driver charges are included."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Booking and Assistance",
    "WhyChoosedescription": "Our support team is available around the clock to help with bookings or answer any queries related to your trip."
  },
  {
    "WhyChooseheading": "Flexible Packages for One-Way and Round Trips",
    "WhyChoosedescription": "Select from hourly, daily, or customized rental plans for your Pune to Indore travel needs."
  },
  {
    "WhyChooseheading": "Instant Online Booking with Real-Time Confirmation",
    "WhyChoosedescription": "Book your cab easily through our website or app with immediate confirmation and secure payment options."
  }
]

















    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs offer Pune to Indore cab service?',
        answer: 'Yes, Platinum24 Cabs provides efficient and comfortable cab services from Pune to Indore with professional drivers and clean vehicles.',
    },
    {
        question: 'How can I book a cab from Pune to Indore with Platinum24 Cabs?',
        answer: 'You can book your cab easily through our website, mobile app, or by contacting our 24x7 customer support.',
    },
    {
        question: 'What types of vehicles are available for Pune to Indore travel?',
        answer: 'We offer a range of vehicles including hatchbacks, sedans, SUVs, and luxury cars to suit your travel preferences and budget.',
    },
    {
        question: 'Is one-way cab service available from Pune to Indore?',
        answer: 'Yes, we offer both one-way and round-trip cab services from Pune to Indore.',
    },
    {
        question: 'Are the drivers experienced for Pune to Indore travel?',
        answer: 'Absolutely, our drivers are experienced, licensed, and familiar with the Pune to Indore route.',
    },
    {
        question: 'Can I select custom pickup and drop-off locations in Pune and Indore?',
        answer: 'Yes, you can customize your pickup and drop-off points for maximum convenience.',
    },
    {
        question: 'What safety measures are taken for Pune to Indore cabs?',
        answer: 'Our cabs are thoroughly sanitized, and drivers follow strict hygiene and safety protocols during the journey.',
    },
    {
        question: 'Is the Pune to Indore cab service available 24x7?',
        answer: 'Yes, Platinum24 Cabs operates 24x7, allowing you to book a cab from Pune to Indore anytime.',
    },
    {
        question: 'What payment methods are accepted for Pune to Indore cab bookings?',
        answer: 'We accept UPI, digital wallets, credit/debit cards, and cash for easy and flexible payments.',
    },
    {
        question: 'Are customizable packages available for Pune to Indore cab travel?',
        answer: 'Yes, we offer flexible and customizable travel packages to meet your needs and travel plans.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Rohit Malviya',
        feedback: 'I traveled from Pune to Indore with Platinum24 Cabs — great experience, smooth ride, and on-time pickup.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Shraddha Patil',
        feedback: 'The cab was clean, the driver was courteous, and the overall service from Pune to Indore was excellent!',
        rating: 5,
    },
];







































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];









const puneToIndoreCabSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Indore Cab Service",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-indore-cab.jpg",
  "description": "Book Pune to Indore cab service with Platinum24 Cabs. Choose from affordable sedans, SUVs, and reliable outstation taxis for one-way and round trips. Comfortable and available 24/7.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "32150",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5299",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-indore-cab-service"
  }
};





    return (
        <div>

<Helmet>
  <title>Pune to Indore Cab Service | Affordable Outstation Taxi | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book Pune to Indore cab service with Platinum24 Cabs. Choose from affordable sedans, SUVs, and reliable outstation taxis for one-way and round trips. Comfortable and available 24/7."
  />
  <meta
    name="keywords"
    content="Pune to Indore Cab, Pune to Indore Taxi, Book Pune to Indore Cab, Pune to Indore Cab Service, Pune to Indore Cab Fare, Pune to Indore One Way Taxi, Cab from Pune to Indore, Indore to Pune Cab Booking, Pune to Indore Car Rental, Affordable Cabs Pune to Indore, Pune to Indore Outstation Cab, Pune to Indore Sedan and SUV, Pune to Indore Cab Charges"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToIndoreCabSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/101.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoindorecab;